'use strict';
var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { 'default': mod };
};
Object.defineProperty(exports, '__esModule', { value: true });
const appServiceSdk_js_1 = require('../__gen__/appServiceSdk');
exports.VLLocales = appServiceSdk_js_1.CmsLocalesEnum;
const package_json_1 = __importDefault(require('../package'));
exports.VL_CLIENT_VERSION = package_json_1.default.version;    //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudEludGVyZmFjZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY21zL2NvbnRlbnRJbnRlcmZhY2VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBRUEsK0RBR2tDO0FBS3pCLG9CQVBXLGlDQUFTLENBT1g7QUFKbEIsbUVBQW1DO0FBRXRCLFFBQUEsaUJBQWlCLEdBQUcsc0JBQUksQ0FBQyxPQUFPLENBQUMifQ==
